import { VueConstructor } from 'vue';
import { VideoOverlayPresentation } from '@/scripts/pages/video/VideoPlayerOverlaysManager/controllers/VideoOverlayPresentation';

/**
 * VideoOverlay Priority. A higher number signify a higher priority
 */
export enum VideoOverlayPriority {
  Info,
  LoadingError,
  BlockedError,
  UserInteraction,
}
export enum VideoOverlayType {
  Dismissable,
  Error,
  Blocking,
}

export interface VideoOverlay {
  name: string;
  priority: VideoOverlayPriority;
  type: VideoOverlayType;
  createdAt: number;
  component?: () => Promise<VueConstructor> | VueConstructor;
  presentation?: VideoOverlayPresentation;
}
